export default "__VITE_ASSET__BIY0Lpsr__"